import ROUTES from '@/constants/legacy/constRoutes'
import { QueryStringKeyEnum } from '@/constants/query-string-key.enum'
import { useWelcomeDealEventTracker } from '@/containers/event-tracker/welcome-deal.event-tracker'
import { useCustomRouter } from '@/containers/hooks'
import { AdPetType } from '@/graphql/generated/schemas'
import { Bridge } from '@/utils/bridge/bridge'
import appBridgeProvider, { isInAppFlag } from '@/utils/utilBridge'

type UseEvent100WonDealProps = {
  petType: AdPetType
}

const useEvent100WonDeal = ({ petType }: UseEvent100WonDealProps) => {
  const { asPath, push } = useCustomRouter()
  const { trackClick100WondealSignupEvent } = useWelcomeDealEventTracker()
  const goToRegister = () => {
    trackClick100WondealSignupEvent(petType)
    if (isInAppFlag) {
      appBridgeProvider((bridge: Bridge) => {
        bridge.goAccountsRegister()
        window.onforeground = () => {
          const token = window.getToken()
          if (token && token.apiToken.token.length > 0) {
            location.reload()
          }
        }
      })
    } else {
      push({
        pathname: ROUTES.ACCOUNTS.LOGIN,
        query: {
          [QueryStringKeyEnum.ReturnUrl]: asPath,
        },
      })
    }
  }
  return {
    goToRegister,
  }
}

export { useEvent100WonDeal }
